import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import { knowledgeAreaRoute, knowledgeDomainRoute, knowledgeItemRoute } from 'lib/constants/routes'
import {
    seoSubjectsRoute,
    subjectsTopicRoute,
    taxonomyLevelOne,
    taxonomyLevelThree,
    taxonomyLevelTwo,
} from 'lib/constants/routes'

export type BreadcrumbItem = {
    label: string
    href: string
    isNotALink?: true
}

interface GenerateBreadcrumbsParams {
    knowSeoInfo: KnowSeoInfo
    showKnowledgeAreaBreadcrumbs?: boolean
    minimalizeBreadCrumbs?: boolean
    t: (key: string) => string
}

export const generateBreadcrumbs = ({
    knowSeoInfo,
    showKnowledgeAreaBreadcrumbs,
    minimalizeBreadCrumbs,
    t,
}: GenerateBreadcrumbsParams): BreadcrumbItem[] => {
    const { knowledgeArea } = knowSeoInfo

    let parts: BreadcrumbItem[] = []

    const temporarilyDisableKnowledgeAreaBreadcrumbs = true

    if (showKnowledgeAreaBreadcrumbs && knowledgeArea && !temporarilyDisableKnowledgeAreaBreadcrumbs) {
        // Use knowledge area breadcrumbs
        if (knowledgeArea?.slug && knowledgeArea?.name) {
            parts.push({
                label: knowledgeArea.name,
                href: knowledgeAreaRoute(knowledgeArea.slug),
            })

            if (knowledgeArea.knowledgeDomain?.slug && knowledgeArea.knowledgeDomain?.name) {
                parts.push({
                    label: knowledgeArea.knowledgeDomain.name,
                    href: knowledgeDomainRoute(knowledgeArea.slug, knowledgeArea.knowledgeDomain.slug),
                })

                if (knowledgeArea.knowledgeDomain.knowledgeItem?.slug && knowledgeArea.knowledgeDomain.knowledgeItem?.name) {
                    parts.push({
                        label: knowledgeArea.knowledgeDomain.knowledgeItem.name,
                        href: knowledgeItemRoute(
                            knowledgeArea.slug,
                            knowledgeArea.knowledgeDomain.slug,
                            knowledgeArea.knowledgeDomain.knowledgeItem.slug
                        ),
                    })
                }
            }
        }

        if (knowSeoInfo.title) {
            parts.push({
                label: knowSeoInfo.title,
                href: '',
                isNotALink: true,
            })
        }
    } else {
        // Use taxonomy-based breadcrumbs
        const {
            topicsPath,
            know: { subjects },
        } = knowSeoInfo

        const initialSubject = subjects?.length ? subjects[0] : null

        parts =
            topicsPath?.length && topicsPath[0] && topicsPath[1]
                ? [
                      {
                          label: topicsPath[0].name,
                          href: taxonomyLevelOne(topicsPath[0].slug),
                      },
                      {
                          label: topicsPath[1].name,
                          href: taxonomyLevelTwo(topicsPath[0].slug, topicsPath[1].slug),
                      },
                  ]
                : []

        if (topicsPath?.length >= 3 && topicsPath[2]) {
            parts = [
                ...parts,
                {
                    label: topicsPath[2].name,
                    href: taxonomyLevelThree(topicsPath[0].slug, topicsPath[2].slug),
                },
                {
                    label: knowSeoInfo?.title,
                    href: '',
                    isNotALink: true,
                },
            ]
        } else {
            parts = [
                ...parts,
                {
                    label: knowSeoInfo?.title,
                    href: '',
                    isNotALink: true,
                },
            ]
        }

        if (initialSubject) {
            parts = [
                {
                    label: t('common/navBarMenuSubjectMenuItem'),
                    href: seoSubjectsRoute,
                },
                {
                    label: initialSubject.name,
                    href: subjectsTopicRoute(initialSubject),
                },
                ...parts,
            ]
        }
    }

    if (minimalizeBreadCrumbs) {
        parts.pop()
    }

    return parts
}
